import { Ok } from 'ts-results';
import { parsePulserSequence } from './pulser-schema';
import type { PulserSchemaError, PulserSequence } from './pulser-schema';
import type { Result } from 'ts-results';
import type { ValidationError } from '~/util/validation';

/**
 * Import and validate uploaded experiment from unknown JS object.
 *
 * Can handle files in Pulser sequence serialization format.
 *
 * Safe to use on unknown object straight after JSON parsing.
 */
export function parseUploadedExperiment(
  jsValue: unknown
): Result<PulserSequence, ValidationError | PulserSchemaError> {
  const result = parsePulserSequence(jsValue);
  if (result.err) {
    return result;
  }
  return Ok(result.safeUnwrap());
}
